// 자동 생성 파일 — scripts/gen-countries.mjs 로 다시 만든다. 손으로 고치지 말 것.
// 원본: everbluesea-vault/data/ref/country_names_ko.json (216개국)
// 표기 보정·별칭은 src/lib/countryAliases.ts

export interface CountryName {
  iso3: string;
  /** 한국어 짧은 이름 (원본 ko) */
  ko: string;
  /** 한국어 정식 이름 (원본 ko_full) */
  koFull: string;
  /** 영어 이름 (원본 en, ISO 표기) */
  en: string;
}

export const countryNames: CountryName[] = [
  { iso3: "ABW", ko: "아루바", koFull: "아루바", en: "Aruba" },
  { iso3: "ADO", ko: "안도라", koFull: "안도라", en: "Andorra" },
  { iso3: "AFG", ko: "아프가니스탄", koFull: "아프가니스탄", en: "Afghanistan" },
  { iso3: "AGO", ko: "앙골라", koFull: "앙골라", en: "Angola" },
  { iso3: "AIA", ko: "앵귈라", koFull: "앵귈라", en: "Anguilla" },
  { iso3: "ALB", ko: "알바니아", koFull: "알바니아", en: "Albania" },
  { iso3: "ANT", ko: "네덜란드령 안틸레스", koFull: "네덜란드령 안틸레스", en: "Netherlands Antilles" },
  { iso3: "ARE", ko: "아랍에미리트", koFull: "아랍에미리트", en: "United Arab Emirates" },
  { iso3: "ARG", ko: "아르헨티나", koFull: "아르헨티나", en: "Argentina" },
  { iso3: "ARM", ko: "아르메니아", koFull: "아르메니아", en: "Armenia" },
  { iso3: "ASM", ko: "아메리칸사모아", koFull: "아메리칸사모아", en: "American Samoa" },
  { iso3: "ATG", ko: "앤티가 바부다", koFull: "앤티가 바부다", en: "Antigua and Barbuda" },
  { iso3: "AUS", ko: "오스트레일리아", koFull: "오스트레일리아", en: "Australia" },
  { iso3: "AUT", ko: "오스트리아", koFull: "오스트리아", en: "Austria" },
  { iso3: "AZE", ko: "아제르바이잔", koFull: "아제르바이잔", en: "Azerbaijan" },
  { iso3: "BDI", ko: "부룬디", koFull: "부룬디", en: "Burundi" },
  { iso3: "BEL", ko: "벨기에", koFull: "벨기에", en: "Belgium" },
  { iso3: "BEN", ko: "베냉", koFull: "베냉", en: "Benin" },
  { iso3: "BFA", ko: "부르키나파소", koFull: "부르키나파소", en: "Burkina Faso" },
  { iso3: "BGD", ko: "방글라데시", koFull: "방글라데시", en: "Bangladesh" },
  { iso3: "BGR", ko: "불가리아", koFull: "불가리아", en: "Bulgaria" },
  { iso3: "BHR", ko: "바레인", koFull: "바레인", en: "Bahrain" },
  { iso3: "BHS", ko: "바하마", koFull: "바하마", en: "Bahamas" },
  { iso3: "BIH", ko: "보스니아 헤르체고비나", koFull: "보스니아 헤르체고비나", en: "Bosnia and Herzegovina" },
  { iso3: "BLR", ko: "벨라루스", koFull: "벨라루스", en: "Belarus" },
  { iso3: "BLZ", ko: "벨리즈", koFull: "벨리즈", en: "Belize" },
  { iso3: "BMU", ko: "버뮤다", koFull: "버뮤다", en: "Bermuda" },
  { iso3: "BOL", ko: "볼리비아 다국가 연합국", koFull: "볼리비아 다국가 연합국", en: "Bolivia, Plurinational State of" },
  { iso3: "BRA", ko: "브라질", koFull: "브라질", en: "Brazil" },
  { iso3: "BRB", ko: "바베이도스", koFull: "바베이도스", en: "Barbados" },
  { iso3: "BRN", ko: "브루나이 다루살람", koFull: "브루나이 다루살람", en: "Brunei Darussalam" },
  { iso3: "BTN", ko: "부탄", koFull: "부탄", en: "Bhutan" },
  { iso3: "BWA", ko: "보츠와나", koFull: "보츠와나", en: "Botswana" },
  { iso3: "CAF", ko: "중앙아프리카 공화국", koFull: "중앙아프리카 공화국", en: "Central African Republic" },
  { iso3: "CAN", ko: "캐나다", koFull: "캐나다", en: "Canada" },
  { iso3: "CHE", ko: "스위스", koFull: "스위스", en: "Switzerland" },
  { iso3: "CHL", ko: "칠레", koFull: "칠레", en: "Chile" },
  { iso3: "CHN", ko: "중국", koFull: "중국", en: "China" },
  { iso3: "CIV", ko: "코트디부아르", koFull: "코트디부아르", en: "Côte d'Ivoire" },
  { iso3: "CMR", ko: "카메룬", koFull: "카메룬", en: "Cameroon" },
  { iso3: "COD", ko: "콩고 민주 공화국", koFull: "콩고 민주 공화국", en: "Congo, The Democratic Republic of the" },
  { iso3: "COG", ko: "콩고", koFull: "콩고", en: "Congo" },
  { iso3: "COK", ko: "쿡 제도", koFull: "쿡 제도", en: "Cook Islands" },
  { iso3: "COL", ko: "콜롬비아", koFull: "콜롬비아", en: "Colombia" },
  { iso3: "COM", ko: "코모로", koFull: "코모로", en: "Comoros" },
  { iso3: "CPV", ko: "카보베르데", koFull: "카보베르데", en: "Cabo Verde" },
  { iso3: "CRI", ko: "코스타리카", koFull: "코스타리카", en: "Costa Rica" },
  { iso3: "CUB", ko: "쿠바", koFull: "쿠바", en: "Cuba" },
  { iso3: "CYM", ko: "케이맨 제도", koFull: "케이맨 제도", en: "Cayman Islands" },
  { iso3: "CYP", ko: "키프로스", koFull: "키프로스", en: "Cyprus" },
  { iso3: "CZE", ko: "체코", koFull: "체코", en: "Czechia" },
  { iso3: "DEU", ko: "독일", koFull: "독일", en: "Germany" },
  { iso3: "DJI", ko: "지부티", koFull: "지부티", en: "Djibouti" },
  { iso3: "DMA", ko: "도미니카 연방", koFull: "도미니카 연방", en: "Dominica" },
  { iso3: "DNK", ko: "덴마크", koFull: "덴마크", en: "Denmark" },
  { iso3: "DOM", ko: "도미니카 공화국", koFull: "도미니카 공화국", en: "Dominican Republic" },
  { iso3: "DZA", ko: "알제리", koFull: "알제리", en: "Algeria" },
  { iso3: "ECU", ko: "에콰도르", koFull: "에콰도르", en: "Ecuador" },
  { iso3: "EGY", ko: "이집트", koFull: "이집트", en: "Egypt" },
  { iso3: "ERI", ko: "에리트레아", koFull: "에리트레아", en: "Eritrea" },
  { iso3: "ESP", ko: "스페인", koFull: "스페인", en: "Spain" },
  { iso3: "EST", ko: "에스토니아", koFull: "에스토니아", en: "Estonia" },
  { iso3: "ETH", ko: "에티오피아", koFull: "에티오피아", en: "Ethiopia" },
  { iso3: "FIN", ko: "핀란드", koFull: "핀란드", en: "Finland" },
  { iso3: "FJI", ko: "피지", koFull: "피지", en: "Fiji" },
  { iso3: "FRA", ko: "프랑스", koFull: "프랑스", en: "France" },
  { iso3: "FSM", ko: "미크로네시아 연방", koFull: "미크로네시아 연방", en: "Micronesia, Federated States of" },
  { iso3: "GAB", ko: "가봉", koFull: "가봉", en: "Gabon" },
  { iso3: "GBR", ko: "영국", koFull: "영국", en: "United Kingdom" },
  { iso3: "GEO", ko: "조지아", koFull: "조지아", en: "Georgia" },
  { iso3: "GHA", ko: "가나", koFull: "가나", en: "Ghana" },
  { iso3: "GIN", ko: "기니", koFull: "기니", en: "Guinea" },
  { iso3: "GMB", ko: "감비아", koFull: "감비아", en: "Gambia" },
  { iso3: "GNB", ko: "기니비사우", koFull: "기니비사우", en: "Guinea-Bissau" },
  { iso3: "GNQ", ko: "적도 기니", koFull: "적도 기니", en: "Equatorial Guinea" },
  { iso3: "GRC", ko: "그리스", koFull: "그리스", en: "Greece" },
  { iso3: "GRD", ko: "그레나다", koFull: "그레나다", en: "Grenada" },
  { iso3: "GRL", ko: "그린란드", koFull: "그린란드", en: "Greenland" },
  { iso3: "GTM", ko: "과테말라", koFull: "과테말라", en: "Guatemala" },
  { iso3: "GUF", ko: "프랑스령 기아나", koFull: "프랑스령 기아나", en: "French Guiana" },
  { iso3: "GUM", ko: "괌", koFull: "괌", en: "Guam" },
  { iso3: "GUY", ko: "가이아나", koFull: "가이아나", en: "Guyana" },
  { iso3: "HKG", ko: "홍콩", koFull: "홍콩", en: "Hong Kong" },
  { iso3: "HND", ko: "온두라스", koFull: "온두라스", en: "Honduras" },
  { iso3: "HRV", ko: "크로아티아", koFull: "크로아티아", en: "Croatia" },
  { iso3: "HTI", ko: "아이티", koFull: "아이티", en: "Haiti" },
  { iso3: "HUN", ko: "헝가리", koFull: "헝가리", en: "Hungary" },
  { iso3: "IDN", ko: "인도네시아", koFull: "인도네시아", en: "Indonesia" },
  { iso3: "IND", ko: "인도", koFull: "인도", en: "India" },
  { iso3: "IRL", ko: "아일랜드", koFull: "아일랜드", en: "Ireland" },
  { iso3: "IRN", ko: "이란 이슬람 공화국", koFull: "이란 이슬람 공화국", en: "Iran, Islamic Republic of" },
  { iso3: "IRQ", ko: "이라크", koFull: "이라크", en: "Iraq" },
  { iso3: "ISL", ko: "아이슬란드", koFull: "아이슬란드", en: "Iceland" },
  { iso3: "ISR", ko: "이스라엘", koFull: "이스라엘", en: "Israel" },
  { iso3: "ITA", ko: "이탈리아", koFull: "이탈리아", en: "Italy" },
  { iso3: "JAM", ko: "자메이카", koFull: "자메이카", en: "Jamaica" },
  { iso3: "JEY", ko: "저지 섬", koFull: "저지 섬", en: "Jersey" },
  { iso3: "JOR", ko: "요르단", koFull: "요르단", en: "Jordan" },
  { iso3: "JPN", ko: "일본", koFull: "일본", en: "Japan" },
  { iso3: "KAZ", ko: "카자흐스탄", koFull: "카자흐스탄", en: "Kazakhstan" },
  { iso3: "KEN", ko: "케냐", koFull: "케냐", en: "Kenya" },
  { iso3: "KGZ", ko: "키르기스스탄", koFull: "키르기스스탄", en: "Kyrgyzstan" },
  { iso3: "KHM", ko: "캄보디아", koFull: "캄보디아", en: "Cambodia" },
  { iso3: "KIR", ko: "키리바시", koFull: "키리바시", en: "Kiribati" },
  { iso3: "KNA", ko: "세인트키츠 네비스", koFull: "세인트키츠 네비스", en: "Saint Kitts and Nevis" },
  { iso3: "KOR", ko: "대한민국", koFull: "대한민국", en: "Korea, Republic of" },
  { iso3: "KWT", ko: "쿠웨이트", koFull: "쿠웨이트", en: "Kuwait" },
  { iso3: "LAO", ko: "라오 인민 민주주의 공화국", koFull: "라오 인민 민주주의 공화국", en: "Lao People's Democratic Republic" },
  { iso3: "LBN", ko: "레바논", koFull: "레바논", en: "Lebanon" },
  { iso3: "LBR", ko: "라이베리아", koFull: "라이베리아", en: "Liberia" },
  { iso3: "LBY", ko: "리비아", koFull: "리비아", en: "Libya" },
  { iso3: "LCA", ko: "세인트루시아", koFull: "세인트루시아", en: "Saint Lucia" },
  { iso3: "LIE", ko: "리히텐슈타인", koFull: "리히텐슈타인", en: "Liechtenstein" },
  { iso3: "LKA", ko: "스리랑카", koFull: "스리랑카", en: "Sri Lanka" },
  { iso3: "LSO", ko: "레소토", koFull: "레소토", en: "Lesotho" },
  { iso3: "LTU", ko: "리투아니아", koFull: "리투아니아", en: "Lithuania" },
  { iso3: "LUX", ko: "룩셈부르크", koFull: "룩셈부르크", en: "Luxembourg" },
  { iso3: "LVA", ko: "라트비아", koFull: "라트비아", en: "Latvia" },
  { iso3: "MAC", ko: "마카오", koFull: "마카오", en: "Macao" },
  { iso3: "MAR", ko: "모로코", koFull: "모로코", en: "Morocco" },
  { iso3: "MCO", ko: "모나코", koFull: "모나코", en: "Monaco" },
  { iso3: "MDA", ko: "몰도바 공화국", koFull: "몰도바 공화국", en: "Moldova, Republic of" },
  { iso3: "MDG", ko: "마다가스카르", koFull: "마다가스카르", en: "Madagascar" },
  { iso3: "MDV", ko: "몰디브", koFull: "몰디브", en: "Maldives" },
  { iso3: "MEX", ko: "멕시코", koFull: "멕시코", en: "Mexico" },
  { iso3: "MHL", ko: "마셜 제도", koFull: "마셜 제도", en: "Marshall Islands" },
  { iso3: "MKD", ko: "북마케도니아", koFull: "북마케도니아", en: "North Macedonia" },
  { iso3: "MLI", ko: "말리", koFull: "말리", en: "Mali" },
  { iso3: "MLT", ko: "몰타", koFull: "몰타", en: "Malta" },
  { iso3: "MMR", ko: "미얀마", koFull: "미얀마", en: "Myanmar" },
  { iso3: "MNE", ko: "몬테네그로", koFull: "몬테네그로", en: "Montenegro" },
  { iso3: "MNG", ko: "몽골", koFull: "몽골", en: "Mongolia" },
  { iso3: "MOZ", ko: "모잠비크", koFull: "모잠비크", en: "Mozambique" },
  { iso3: "MRT", ko: "모리타니", koFull: "모리타니", en: "Mauritania" },
  { iso3: "MTQ", ko: "마르티니크", koFull: "마르티니크", en: "Martinique" },
  { iso3: "MUS", ko: "모리셔스", koFull: "모리셔스", en: "Mauritius" },
  { iso3: "MWI", ko: "말라위", koFull: "말라위", en: "Malawi" },
  { iso3: "MYS", ko: "말레이시아", koFull: "말레이시아", en: "Malaysia" },
  { iso3: "NAM", ko: "나미비아", koFull: "나미비아", en: "Namibia" },
  { iso3: "NCL", ko: "누벨칼레도니", koFull: "누벨칼레도니", en: "New Caledonia" },
  { iso3: "NER", ko: "니제르", koFull: "니제르", en: "Niger" },
  { iso3: "NGA", ko: "나이지리아", koFull: "나이지리아", en: "Nigeria" },
  { iso3: "NIC", ko: "니카라과", koFull: "니카라과", en: "Nicaragua" },
  { iso3: "NIU", ko: "니우에", koFull: "니우에", en: "Niue" },
  { iso3: "NLD", ko: "네덜란드", koFull: "네덜란드", en: "Netherlands" },
  { iso3: "NOR", ko: "노르웨이", koFull: "노르웨이", en: "Norway" },
  { iso3: "NPL", ko: "네팔", koFull: "네팔", en: "Nepal" },
  { iso3: "NRU", ko: "나우루", koFull: "나우루", en: "Nauru" },
  { iso3: "NZL", ko: "뉴질랜드", koFull: "뉴질랜드", en: "New Zealand" },
  { iso3: "OMN", ko: "오만", koFull: "오만", en: "Oman" },
  { iso3: "PAK", ko: "파키스탄", koFull: "파키스탄", en: "Pakistan" },
  { iso3: "PAN", ko: "파나마", koFull: "파나마", en: "Panama" },
  { iso3: "PER", ko: "페루", koFull: "페루", en: "Peru" },
  { iso3: "PHL", ko: "필리핀", koFull: "필리핀", en: "Philippines" },
  { iso3: "PLW", ko: "팔라우", koFull: "팔라우", en: "Palau" },
  { iso3: "PNG", ko: "파푸아뉴기니", koFull: "파푸아뉴기니", en: "Papua New Guinea" },
  { iso3: "POL", ko: "폴란드", koFull: "폴란드", en: "Poland" },
  { iso3: "PRI", ko: "푸에르토리코", koFull: "푸에르토리코", en: "Puerto Rico" },
  { iso3: "PRK", ko: "조선민주주의인민공화국", koFull: "조선민주주의인민공화국", en: "Korea, Democratic People's Republic of" },
  { iso3: "PRT", ko: "포르투갈", koFull: "포르투갈", en: "Portugal" },
  { iso3: "PRY", ko: "파라과이", koFull: "파라과이", en: "Paraguay" },
  { iso3: "PSE", ko: "팔레스타인", koFull: "팔레스타인", en: "Palestine, State of" },
  { iso3: "PYF", ko: "프랑스령 폴리네시아", koFull: "프랑스령 폴리네시아", en: "French Polynesia" },
  { iso3: "QAT", ko: "카타르", koFull: "카타르", en: "Qatar" },
  { iso3: "REU", ko: "레위니옹", koFull: "레위니옹", en: "Réunion" },
  { iso3: "ROU", ko: "루마니아", koFull: "루마니아", en: "Romania" },
  { iso3: "RUS", ko: "러시아 연방", koFull: "러시아 연방", en: "Russian Federation" },
  { iso3: "RWA", ko: "르완다", koFull: "르완다", en: "Rwanda" },
  { iso3: "SAU", ko: "사우디아라비아", koFull: "사우디아라비아", en: "Saudi Arabia" },
  { iso3: "SDN", ko: "수단", koFull: "수단", en: "Sudan" },
  { iso3: "SEN", ko: "세네갈", koFull: "세네갈", en: "Senegal" },
  { iso3: "SGP", ko: "싱가포르", koFull: "싱가포르", en: "Singapore" },
  { iso3: "SLB", ko: "솔로몬 제도", koFull: "솔로몬 제도", en: "Solomon Islands" },
  { iso3: "SLE", ko: "시에라리온", koFull: "시에라리온", en: "Sierra Leone" },
  { iso3: "SLV", ko: "엘살바도르", koFull: "엘살바도르", en: "El Salvador" },
  { iso3: "SMR", ko: "산마리노", koFull: "산마리노", en: "San Marino" },
  { iso3: "SOM", ko: "소말리아", koFull: "소말리아", en: "Somalia" },
  { iso3: "SRB", ko: "세르비아", koFull: "세르비아", en: "Serbia" },
  { iso3: "SSD", ko: "남수단", koFull: "남수단", en: "South Sudan" },
  { iso3: "STP", ko: "상투메 프린시페", koFull: "상투메 프린시페", en: "Sao Tome and Principe" },
  { iso3: "SUR", ko: "수리남", koFull: "수리남", en: "Suriname" },
  { iso3: "SVK", ko: "슬로바키아", koFull: "슬로바키아", en: "Slovakia" },
  { iso3: "SVN", ko: "슬로베니아", koFull: "슬로베니아", en: "Slovenia" },
  { iso3: "SWE", ko: "스웨덴", koFull: "스웨덴", en: "Sweden" },
  { iso3: "SWZ", ko: "에스와티니", koFull: "에스와티니", en: "Eswatini" },
  { iso3: "SYC", ko: "세이셸", koFull: "세이셸", en: "Seychelles" },
  { iso3: "SYR", ko: "시리아 아랍 공화국", koFull: "시리아 아랍 공화국", en: "Syrian Arab Republic" },
  { iso3: "TCD", ko: "차드", koFull: "차드", en: "Chad" },
  { iso3: "TGO", ko: "토고", koFull: "토고", en: "Togo" },
  { iso3: "THA", ko: "태국", koFull: "태국", en: "Thailand" },
  { iso3: "TJK", ko: "타지키스탄", koFull: "타지키스탄", en: "Tajikistan" },
  { iso3: "TKM", ko: "투르크메니스탄", koFull: "투르크메니스탄", en: "Turkmenistan" },
  { iso3: "TLS", ko: "동티모르", koFull: "동티모르", en: "Timor-Leste" },
  { iso3: "TON", ko: "통가", koFull: "통가", en: "Tonga" },
  { iso3: "TTO", ko: "트리니다드 토바고", koFull: "트리니다드 토바고", en: "Trinidad and Tobago" },
  { iso3: "TUN", ko: "튀니지", koFull: "튀니지", en: "Tunisia" },
  { iso3: "TUR", ko: "튀르키예", koFull: "튀르키예", en: "Türkiye" },
  { iso3: "TUV", ko: "투발루", koFull: "투발루", en: "Tuvalu" },
  { iso3: "TWN", ko: "타이완, 중국령", koFull: "타이완, 중국령", en: "Taiwan, Province of China" },
  { iso3: "TZA", ko: "탄자니아 연방 공화국", koFull: "탄자니아 연방 공화국", en: "Tanzania, United Republic of" },
  { iso3: "UGA", ko: "우간다", koFull: "우간다", en: "Uganda" },
  { iso3: "UKR", ko: "우크라이나", koFull: "우크라이나", en: "Ukraine" },
  { iso3: "URY", ko: "우루과이", koFull: "우루과이", en: "Uruguay" },
  { iso3: "USA", ko: "미국", koFull: "미국", en: "United States" },
  { iso3: "UZB", ko: "우즈베키스탄", koFull: "우즈베키스탄", en: "Uzbekistan" },
  { iso3: "VCT", ko: "세인트빈센트 그레나딘", koFull: "세인트빈센트 그레나딘", en: "Saint Vincent and the Grenadines" },
  { iso3: "VEN", ko: "베네수엘라 볼리바르 공화국", koFull: "베네수엘라 볼리바르 공화국", en: "Venezuela, Bolivarian Republic of" },
  { iso3: "VIR", ko: "버진 제도, 미국령", koFull: "버진 제도, 미국령", en: "Virgin Islands, U.S." },
  { iso3: "VNM", ko: "베트남", koFull: "베트남", en: "Viet Nam" },
  { iso3: "VUT", ko: "바누아투", koFull: "바누아투", en: "Vanuatu" },
  { iso3: "WSM", ko: "사모아", koFull: "사모아", en: "Samoa" },
  { iso3: "XKX", ko: "코소보", koFull: "코소보", en: "Kosovo" },
  { iso3: "YEM", ko: "예멘", koFull: "예멘", en: "Yemen" },
  { iso3: "ZAF", ko: "남아프리카 공화국", koFull: "남아프리카 공화국", en: "South Africa" },
  { iso3: "ZMB", ko: "잠비아", koFull: "잠비아", en: "Zambia" },
  { iso3: "ZWE", ko: "짐바브웨", koFull: "짐바브웨", en: "Zimbabwe" },
];
